import React, { useContext } from 'react';
import classNames from 'classnames';
import DataRoomDocumentsContext from '../../providers/DataRoomDocuments/DataRoomDocuments.context';
import DataRoomUploadActions from '../DataRoomUploadActions';
import ViewAs from '../ViewAs';
import useMatchMedia from 'hooks/useMatchMedia';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import DownloadAllNodes from '../DownloadAllNodes';
import CreateShareableLinkButton from '../../CreateShareableLinkButton';
import FolderPath from 'components/FolderPath';
import SelectAllButton from '../SelectAllButton';
import ExtendFileAccess from '../ExtendFileAccess';

import './DataRoomDocHeader.styles.scss';
import './DataRoomDocHeader.styles.responsive.scss';

type DataRoomDocHeaderProps = {
  className?: string;
};

const DataRoomDocHeader: React.FC<DataRoomDocHeaderProps> = (props) => {
  const { className } = props;

  const { hasIndexGenerated, doesntHaveAccess } = useContext(DataRoomContext);
  const { baseDocsPath, documentRoute, setCurrentlySelectedFolder } =
    useContext(DataRoomDocumentsContext);

  const isPhablet = useMatchMedia('isPhablet');

  const classes = classNames('data-room-doc-header', className);

  return (
    <div className="data-room-doc-header__wrapper">
      <header className={classes}>
        <FolderPath
          basePath={baseDocsPath}
          showIndex={hasIndexGenerated}
          route={documentRoute}
          onRouteClick={setCurrentlySelectedFolder}
        />

        {!doesntHaveAccess && !isPhablet && (
          <>
            <DownloadAllNodes />
            <SelectAllButton />
            <CreateShareableLinkButton />
            <ViewAs />
            <DataRoomUploadActions />
          </>
        )}
      </header>

      <ExtendFileAccess />
    </div>
  );
};

export default DataRoomDocHeader;
